import { render, staticRenderFns } from "./WeighingLogDetail.vue?vue&type=template&id=3bf982f9"
import script from "./WeighingLogDetail.vue?vue&type=script&lang=js"
export * from "./WeighingLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports